
















































import { Component, Vue } from 'vue-property-decorator';
import { login } from '@/apis/user';
import { getLoginForm, setLoginForm, removeLoginForm } from '@/utils/cookies';
import { UserModule } from '@/store/modules/user';
import { Base64 } from '@/utils/common';
@Component({
	name: 'Login',
})
export default class extends Vue {
	private form1 = { account: '', password: '', remember: false };
	private register() {
		this.$router.push({ path: '/register' });
	}
	private forgetPwd() {
		this.$router.push({ path: '/resetPwd' });
	}
	private async onSubmit() {
		let pwd = this.form1.password;
		const oldPwd = Base64.encode(Base64.decode(this.form1.password));
		if (pwd !== oldPwd) {
			pwd = Base64.encode(this.form1.password);
		}
		this.form1.password = pwd;
		UserModule.login(this.form1).then((res) => {
			if (res.code === 200) {
				this.$router.push({ path: '/home' });
			}
		});
	}
	private mounted() {
		const form = window.localStorage.getItem('loginForm');
		if (form) {
			let newForm = JSON.parse(form);
			if (newForm.remember) {
				this.form1 = newForm;
			}
		}
	}
	get oem() {
		return UserModule.oem;
	}
}
